module.exports = __webpack_public_path__ + "img/sigh01.1ee26b48.png";